import { useTranslation } from "react-i18next";
import { Button } from "components";
const EditActionModalHeader = ({ onCancel, onSubmit, isLoading }) => {
  const { t } = useTranslation();

  return (
    <div className="header-row space-between">
      <div className="header-title">{t("ActionModal.Mode.EditAction")}</div>
      <div className="header-btn-group">
        <Button corners="square" className="action-button" onClick={onCancel}>
          {t("Global.Cancel")}
        </Button>
        <Button
          variant="filled"
          corners="square"
          isLoading={isLoading}
          isDisabled={isLoading}
          className="action-button"
          onClick={onSubmit}
        >
          {t("ActionModal.SubmitButton")}
        </Button>
      </div>
    </div>
  );
};

export default EditActionModalHeader;
